const isAvailable = key => !!(key && key !== 'none' && key !== 'unknown');

export default isAvailable;
